import { RawShaderMaterial, Texture, Vector3 } from 'three'
import VS from './shaders/bubble-vs.glsl'
import FS from './shaders/bubble-fs.glsl'
export default {
  getMaterial() {
    const material = new RawShaderMaterial({
      transparent: true,
      uniforms: {
        time: { value: 0 },
        envMap: { value: new Texture() },
        envMapIntensity: { value: 1 },
        texelHeight: { value: 0 },
        texelWidth: { value: 0 },
        maxMip: { value: 0 },
        opacity: { value: 1 },
        cameraPosition: { value: new Vector3(0, 8.5, -23) },
        fresnelIntensity: { value: 1 }
      },
      depthTest: true,
      depthWrite: false,
      vertexShader: VS,
      fragmentShader: FS
    })

    return material
  }
}
